import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import StyleSheet from 'styles'
import { connect } from 'react-redux'
import { Pagination } from 'components'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/Add'
import { AllocationActions } from 'actionsets'
import { withRouter }        from 'react-router'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import EditIcon from '@material-ui/icons/Edit'
import { SelectionCounter, ConditionalRender, ErrorBox, Allocations } from 'components'
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import PhonelinkIcon from '@material-ui/icons/Phonelink'
import PhonelinkOffIcon from '@material-ui/icons/PhonelinkOff'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Authorization } from 'utils'

export class AllocationsList extends Component{

  static propTypes = {
    totals: PropTypes.object.isRequired,
    allocations: PropTypes.array.isRequired,
    selection: PropTypes.object.isRequired,
    dealSheet: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    AllocationActions.bindActions(this)
    this.state = {
      currentPage: 1
    }
  }

  componentDidMount(){
    this.loadData()
  }

  loadData(){
    this.actions.index({
      dealSheetId: this.props.match.params.id,
      page: this.currentPage,
      filter: {
        active: this.active
      }
    })
  }

  get active(){
    return this.props.selectedTab === 'active'
  }

  get totalPages() {
    return this.props.totalPages || 0
  }

  get currentPage() {
    return this.state.currentPage
  }

  set currentPage(currentPage){
    this.setState({currentPage}, this.loadData)
  }

  get dealSheet(){
    return this.props.dealSheet || {}
  }

  get sharedAttributes(){
    const sharedAttributes = {}
    const uniqueParams = {
      rate:   new Set(),
      amount:      new Set(),
      startDate:   new Set(),
      endDate:     new Set(),
      timezone: new Set(),
      coinPercentage: new Set(),
      tokenPercentage: new Set(),
      hiddenCommissions: false
    }
    this.selectedAllocations.forEach(({rate, amount, startDate, endDate, timezone, organisationCommission: { coinPercentage, tokenPercentage }}) => {
      uniqueParams.rate.add(rate)
      uniqueParams.amount.add(amount)
      uniqueParams.startDate.add(startDate)
      uniqueParams.endDate.add(endDate)
      uniqueParams.timezone.add(timezone)
      uniqueParams.coinPercentage.add(coinPercentage)
      uniqueParams.tokenPercentage.add(tokenPercentage)
    })
    Object.keys(uniqueParams).forEach(key => {
      sharedAttributes[key] = uniqueParams[key].size === 1 ? uniqueParams[key].values().next().value : undefined
    })

    sharedAttributes.organisationCommission = { coinPercentage: sharedAttributes.coinPercentage, tokenPercentage: sharedAttributes.tokenPercentage}
    delete sharedAttributes.coinPercentage
    delete sharedAttributes.tokenPercentage
    return sharedAttributes
  }

  get sharedCommissions(){
    const commissions = {}
    this.selectedAllocations.forEach(({thirdPartyCommissions}) => {
      thirdPartyCommissions.forEach(({thirdParty: { id, name }, coinPercentage, tokenPercentage}) => {
        commissions[`${id}:${coinPercentage},${tokenPercentage}`] = commissions[`${id}:${coinPercentage},${tokenPercentage}`] || {
          thirdParty: {
            id,
            name
          },
          coinPercentage,
          tokenPercentage,
          count: 0
        }
        commissions[`${id}:${coinPercentage},${tokenPercentage}`].count += 1
      })
    })

    const sharedCommissions = []
    Object.entries(commissions).forEach(([identifier, commissionCount]) => {
      const { count, ...commission} = commissionCount
      if(count === this.selectedAllocations.length){
        sharedCommissions.push(commission)
      }else{
        sharedCommissions.hiddenCommissions = true
      }
    })
    return sharedCommissions
  }

  get sharedParams(){
    return {...this.sharedAttributes, thirdPartyCommissions: this.sharedCommissions}
  }

  get selectedAllocations (){
    return Object.values(this.props.selection).filter(x => x)
  }

  get selectedAllocationCount(){
    return this.selectedAllocations.length
  }

  get hasAllSelected(){
    return this.props.allocations.every(({id}) => !!this.props.selection[id] )
  }

  handleAllocationEdit = allocation  => {
    this.actions.setEditAllocationIds({ids: [allocation.id], params: allocation})
    this.props.history.push(`/deal_sheets/${this.props.match.params.id}/allocations/edit`)
  }

  handleNewOrEditAllocation = () => {
    this.selectedAllocationCount ? this.handleEditAllocation() : this.handleNewAllocation()
  }

  handleEditAllocation = () => {
    const allocationIds = this.selectedAllocations.map(alloc => alloc.id)
    this.actions.setEditAllocationIds({ids: allocationIds, params: this.sharedParams})
    this.props.history.push(`/deal_sheets/${this.props.match.params.id}/allocations/edit`)
  }

  handleNewAllocation = () => {
    this.actions.setNewInvestorIds({ids: [], params: null})
    this.props.history.push(`/deal_sheets/${this.props.match.params.id}/allocations/new`)
  }

  handleAllocationDelete = async id => {
    await this.actions.destroy({id})
    this.loadData()
  }

  handleAllocationShow = id => {
    this.props.history.push(`/deal_sheets/${this.props.match.params.id}/allocations/${id}`)
  }

  handleSelectToggle = allocation =>  {
    if(Authorization.issuer){
      this.handleAllocationShow(allocation.id)
    }else{
      this.actions.setSelection({
        ...this.props.selection,
        [allocation.id]: this.props.selection[allocation.id] ? false : allocation
      })
    }
  }

  handleToggleSelectAll = () => {
    const selection = {...this.props.selection}
    if(this.hasAllSelected){
      this.props.allocations.forEach((allocation) => selection[allocation.id] = false)
    }else{
      this.props.allocations.forEach((allocation) => selection[allocation.id] = allocation)
    }
    this.actions.setSelection(selection)
  }

  handleClearSelection = () => {
    this.actions.setSelection({})
  }

  handleTabChange = async (event, selectedTab) => {
    await this.actions.setSelectedTab(selectedTab)
    this.loadData()
  }

  handleAllocationRestore = async ({dealSheetId, userId}) => {
    await this.actions.bulkUpsert({dealSheetId, status: 'active', ids: [userId]})
    this.loadData()
  }

  handleSortOrderChange = async orderParams => {
    await this.actions.setOrderParams(orderParams)
    this.loadData()
  }

  render = () =>
    <div className={styles.wrapper}>
      <Card className={styles.card} variant='raised'>
        <div className={styles('selectionContainer', {selectionContainerVisible: !!this.selectedAllocationCount})}>
          <SelectionCounter selection={this.props.selection} onClear={this.handleClearSelection} selectionType="investors" />
        </div>
        <ConditionalRender className={styles.navigationButtons}
                           value={this.props.selectedTab}
                           requires={this.dealSheet.status !== 'draft' && this.dealSheet.status !== 'pending_review'}
                           component={BottomNavigation} onChange={this.handleTabChange} showLabels>
          <BottomNavigationAction value='active' label="Active" icon={<PhonelinkIcon />} />
          <BottomNavigationAction value='inactive' label="Inactive" icon={<PhonelinkOffIcon />} />
        </ConditionalRender>
        <CardContent className={styles.content}>
          <ErrorBox errors={this.props.errors} onClearErrors={this.actions.clearErrors}/>
          <Pagination className={styles.pagination} totalPages={this.totalPages} page={this.currentPage} onPageSelected={(page) => this.currentPage = page}/>
          <ConditionalRender requires={Authorization.admin} component='div' className={styles.formActions}>
            <FormControlLabel
              className={styles.selectAllLabel}
              label={
                (this.hasAllSelected && this.selectedAllocationCount) ?
                  <span>
                    Deselect All
                  </span> :
                  <span>Select All</span>
                } control={<Checkbox checked={!!(this.hasAllSelected && this.selectedAllocationCount)} onChange={this.handleToggleSelectAll}/>}
              />
          </ConditionalRender>
          <div className={styles.listWrapper}>
            <Allocations.Table
              selection={this.props.selection}
              allocations={this.props.allocations}
              onSelectToggle={this.handleSelectToggle}
              onAllocationEdit={this.handleAllocationEdit}
              onAllocationShow={this.handleAllocationShow}
              onAllocationDelete={this.handleAllocationDelete}
              onAllocationRestore={this.handleAllocationRestore}
              onOrderParamsChange={this.handleSortOrderChange}
              orderBy={this.props.orderBy}
              orderDir={this.props.orderDir}
            />
            {!this.props.allocations.length && <Typography className={styles.noResultsMessage}>No Allocations</Typography>}
            <ConditionalRender requires={Authorization.admin} component={Button}  variant='fab' color='primary' onClick={this.handleNewOrEditAllocation} className={styles.add}>
              {this.selectedAllocationCount ? <EditIcon/> : <AddIcon />}
            </ConditionalRender>
          </div>
          <br/>
          <Pagination className={styles('pagination', 'paginationBottom')} totalPages={this.totalPages} page={this.currentPage} onPageSelected={(page) => this.currentPage = page}/>
          <Allocations.Summary title="Summary" totals={this.props.totals} ticker={this.props.dealSheet.ticker} currencyCode={this.props.dealSheet.currency.code}/>
        </CardContent>
      </Card>
    </div>
}


const styles = StyleSheet({
  navigationButtons: {
    maxWidth: '100vw',
    backgroundColor: '#20173A',
    '@media(min-width: 601px)': {
      borderTopLeftRadius: 8,
    },
  },
  selectionContainer: {
    height: 0,
    transition: 'height 200ms'
  },
  selectionContainerVisible: {
    height: 40
  },
  selectAllLabel: {
    flex: 1,
    margin: '-5px 0'
  },
  formActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'end',
    background: 'rgba(255, 255, 255, 0.2)',
    padding: 10
  },
  noResultsMessage: {
    background: 'rgba(0, 0, 0, 0.5)',
    padding: 10,
    marginTop: 10
  },
  pagination: {
    padding: 0
  },
  paginationBottom: {
    marginTop: 35
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  card: {
    flex: 1,
    minWidth: 300,
    alignSelf: 'flex-start',
    maxWidth: 1200,
    padding: 0,
    margin: '0 0 10px 0'
  },
  listWrapper: {
    position: 'relative',
    padding: 0,
    paddingBottom: 50,
    marginBottom: -50
  },
  add: {
    position: 'absolute !important',
    bottom: 7,
    right: 30
  },
  content: {
    '@media(max-width: 600px)': {
      padding: 0
    }
  },
})

export default connect(({allocations, dealSheets: { dealSheet }}) => { return {...allocations, dealSheet } } )(withRouter(AllocationsList))